import React, { useEffect } from "react";

import { useAuth } from "../../../Data";

const Index = () => {
	const { logOut } = useAuth();

	useEffect(() => {
		(async () => await logOut())();
	});

	return <div>Logging Out...</div>;
};

export default Index;
